/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
/**
 * Provides all nessesary aria-* attributes to create a vaild aria popup trigger.
 * Used in combination of the `@ariaPopup` controller.
 */
export function ariaPopupTrigger() {
    return (target) => target.addInitializer((instance) => new AriaPopupTriggerController(instance));
}
export class AriaPopupTriggerController {
    constructor(host) {
        this.host = host;
        this.host.addController(this);
    }
    hostConnected() {
        if (this.host.hasAttribute('aria-controls') || this.host.ariaControls) {
            this.host.ariaHasPopup = 'true';
            this.host.ariaExpanded = 'false';
        }
    }
}
